import type { U3121TaskAssignment, U3121WorkNature, U3121WorkNatureAssignment } from '../U3121Service';

export function u3121ExtractWorkNatureAssignmentIds(
  assignments: U3121WorkNatureAssignment[] | undefined,
): string[] {
  if (!assignments?.length) return [];
  return assignments.map((item) => item.id).filter((id) => typeof id === 'string' && id.length > 0);
}

/**
 * BL-0648 — aligné import U3121 : sans nature cochée → toutes les tâches actives ;
 * avec nature(s) → union des punchables U3149 (initLU.workNatures[].punchableTaskIds), restreinte au catalogue actif.
 */
export function u3121ResolveTaskIdsFromWorkNatureSelection(
  selectedWorkNatureIds: string[],
  workNatures: U3121WorkNature[],
  activeTaskIds: string[],
): string[] {
  const catalog = new Set(activeTaskIds);
  if (selectedWorkNatureIds.length === 0) {
    return [...activeTaskIds].sort();
  }

  const selected = new Set(selectedWorkNatureIds);
  const union = new Set<string>();
  for (const wn of workNatures) {
    if (!selected.has(wn.id)) continue;
    for (const taskId of wn.punchableTaskIds ?? []) {
      if (catalog.has(taskId)) union.add(taskId);
    }
  }
  return [...union].sort();
}

export function u3121TaskAssignmentsFromTaskIds(taskIds: string[]): U3121TaskAssignment[] {
  return taskIds.map((id) => ({ id }));
}

export function u3121SyncTaskAssignmentsFromWorkNatures<T extends { workNatureAssignments?: U3121WorkNatureAssignment[]; taskAssignments?: U3121TaskAssignment[] }>(
  row: T,
  workNatures: U3121WorkNature[],
  activeTaskIds: string[],
): T {
  const wnIds = u3121ExtractWorkNatureAssignmentIds(row.workNatureAssignments);
  const taskIds = u3121ResolveTaskIdsFromWorkNatureSelection(wnIds, workNatures, activeTaskIds);
  return {
    ...row,
    taskAssignments: u3121TaskAssignmentsFromTaskIds(taskIds),
  };
}
